/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailabilityScheduleResponse
 */
export interface AvailabilityScheduleResponse {
    /**
     * 
     * @type {Date}
     * @memberof AvailabilityScheduleResponse
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof AvailabilityScheduleResponse
     */
    end: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AvailabilityScheduleResponse
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the AvailabilityScheduleResponse interface.
 */
export function instanceOfAvailabilityScheduleResponse(value: object): value is AvailabilityScheduleResponse {
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function AvailabilityScheduleResponseFromJSON(json: any): AvailabilityScheduleResponse {
    return AvailabilityScheduleResponseFromJSONTyped(json, false);
}

export function AvailabilityScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailabilityScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
        'enabled': json['enabled'],
    };
}

export function AvailabilityScheduleResponseToJSON(json: any): AvailabilityScheduleResponse {
    return AvailabilityScheduleResponseToJSONTyped(json, false);
}

export function AvailabilityScheduleResponseToJSONTyped(value?: AvailabilityScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'].toISOString(),
        'end': value['end'].toISOString(),
        'enabled': value['enabled'],
    };
}

